import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { formatDate } from '../../lib/utils';

export function DueReviewsPanel({ data, loading, onSelectEmployee }) {
  if (loading) return <div className="py-10 text-center text-sm text-muted-foreground">Loading…</div>;
  if (!data) return null;
  const rows = (list, label, { futureDate = false } = {}) => (
    <div className="mb-6">
      <h4 className="text-sm font-semibold mb-2">{label} ({list.length})</h4>
      <Table data-testid={`due-reviews-${label.toLowerCase().replace(/\s/g, '-')}-table`}>
        <TableHeader>
          <TableRow>
            <TableHead>Employee</TableHead>
            <TableHead>Last Review</TableHead>
            <TableHead>{futureDate ? 'Next Review Date' : 'Days Overdue'}</TableHead>
            <TableHead>In Progress</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {list.map((e) => (
            <TableRow key={e.id} className="cursor-pointer hover:bg-muted/50" onClick={() => onSelectEmployee(e.id)} data-testid={`due-review-row-${e.id}`}>
              <TableCell className="font-medium">{e.name}</TableCell>
              <TableCell>{e.last_review_date ? formatDate(e.last_review_date) : 'Never'}</TableCell>
              <TableCell>{futureDate ? (e.next_review_date ? formatDate(e.next_review_date) : '—') : (e.days_overdue != null ? e.days_overdue : '—')}</TableCell>
              <TableCell>
                {e.open_review_status ? <Badge className="bg-amber-100 text-amber-800">{e.open_review_status}</Badge> : '—'}
              </TableCell>
            </TableRow>
          ))}
          {list.length === 0 && (
            <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground">None</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );

  return (
    <div data-testid="due-reviews-panel">
      {rows(data.due, 'Due Now')}
      {rows(data.not_reviewed_yet, 'Not Reviewed Yet')}
      {rows(data.scheduled || [], 'Scheduled', { futureDate: true })}
    </div>
  );
}
